// extracted by mini-css-extract-plugin
export default {"container":"schemeEditor_container__30Uq8","noData":"schemeEditor_noData__GqqxC","nodes":"schemeEditor_nodes__XhnBN","isLoading":"schemeEditor_isLoading__GGe5a"};